import React, { type ReactElement, useEffect, useState } from 'react'
import { Col, Form, Input, Row, Select, Switch } from 'antd'
import { connect } from 'react-redux'
import {
    type BussinessStateProps,
    type BussinessAddress,
} from '../../../../../../Types/Client/RegisteredClients/SoleTrader'

import commonStyles from '../../../../../../Utils/Common.less'
import PostCodeInput from '../../../../../../Components/PostCodeInput'
import { type ListFrontEndInterface } from '../../../../../../Types/CommonType'

const BussinessAddressForm = (props: BussinessAddress): ReactElement => {
    const { countryList, isEditing, toggleEditing, form } = props
    const [selectedCountry, setSelectedCountry] = useState<string>('')

    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            const AddressData = {
                busAddress1: address.line_1,
                busAddress2: address.line_2,
                busTown: address.post_town,
                busCountry: countryData?.label ?? '',
                busPostCode: address.postcode,
            }
            form.setFieldsValue(AddressData)
        }
    }, [address])
    const handleCountryChange = (value: string): void => {
        setSelectedCountry(value)
        props.onDateChange(value)
    }
    return (
        <>
            <div className={commonStyles.bussinessToggle}>
                <Switch
                    size="small"
                    checked={isEditing}
                    onChange={toggleEditing}
                />
                <span className={commonStyles.bussinesToggleA}>
                    Same as Home
                </span>
            </div>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    <Form.Item
                        label="Address 1"
                        name="busAddress1"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your address one!',
                            },
                        ]}
                    >
                        <Input allowClear maxLength={100} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    <Form.Item label="Address 2" name="busAddress2">
                        <Input allowClear maxLength={100} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    {' '}
                    <Form.Item
                        label="Town"
                        name="busTown"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your town!',
                            },
                        ]}
                    >
                        <Input allowClear maxLength={50} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    <Form.Item label="Country" name="busCountry">
                        <Select
                            key={countryList.length}
                            allowClear
                            showSearch
                            onChange={handleCountryChange}
                            options={countryList?.map(
                                (country: { label: any }) => ({
                                    value: country.label,
                                    label: country.label,
                                })
                            )}
                            value={selectedCountry}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    <PostCodeInput
                        name="busPostCode"
                        label="Post Code"
                        reuireMessage="Please Enter Post Code"
                        placeHolder={''}
                        setAddressDetails={setAddress}
                    />
                </Col>
            </Row>
        </>
    )
}

const mapStateToProps = (state: any): BussinessStateProps => {
    return {
        countryList: state.common.countryList,
        soleTraderTaps: state.client.soleTraderTaps,
    }
}

export default connect(mapStateToProps)(BussinessAddressForm)
